export const PORTER_SPECIAL_HANDLING = [
  { value: 'fragile', label: 'Fragile' },
  { value: 'glass', label: 'Glass' },
  { value: 'liquid', label: 'Liquid' },
  { value: 'medical', label: 'Medical' },
  { value: 'frozen', label: 'Frozen' },
  { value: 'heavy', label: 'Heavy' },
  { value: 'dangerous', label: 'Dangerous' },
] as const;

export type PorterSpecialHandling = (typeof PORTER_SPECIAL_HANDLING)[number]['value'];

export function slugifyPorterCode(name: string) {
  return name.trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');
}
